<!-- 案由映射 -->
<template>
  <basic-container>
    <leftTreeRightTable
      ref="columnTables"
      :title="'数据映射'"
      :zbParams="{
        dwId: 4840,
      }"
      :cbParams="{
        opId:304,
        dataClass : 2,
      }"
      :zbShow="'MODULE_NAME'"
      :zcbGlgx="{
        parProp: 'ID',
        chilProp: 'MODULE_ID'
      }"
      :ljzParams="{
        key: 'PARENT_ID',
        value: 'ID'
      }"
    >
    </leftTreeRightTable>
  </basic-container>
</template>

<script>
import leftTreeRightTable from "@/components/table/leftTreeRightTable";
export default {
  components: {
    leftTreeRightTable
  },
  data() {
    return {
    };
  },
  computed: {},
  methods: {
  },
  mounted() {},
  activated() {},
};
</script>
<style lang="scss" scoped>
/deep/.el-icon-folder-opened,
/deep/.el-icon-folder {
  color: rgb(255, 192, 1) !important;
}
.aymc-item{
  &:hover{
    color: #2E5AE8;
    cursor: pointer;
  }
}
</style>
